// Tipografía compartida de los charts del reporte (ECharts).
//
// ECharts dibuja los textos del canvas (ejes, leyenda) con la `sans-serif`
// del navegador salvo que se le fije la familia: por eso los ejes se veían
// con otra letra que la app (Phil, 2026-10-08). La familia es la de la app
// (`$family-primary` en `assets/style.scss`, cargada en `public/index.html`)
// y los tamaños son los de los gráficos de Ventas, que son la referencia
// (D4 de `docs/decisiones/37-dashboard-reporte-financiero.md`, 2026-10-08). El tooltip es HTML y ya
// hereda la fuente de la página; su tamaño va acá para que todos coincidan.
export const CHART_FONT_FAMILY = '"Open Sans", sans-serif';

// Va en la raíz de la option (`textStyle`): ECharts lo hereda en todos los
// componentes de texto que no fijen otra familia.
export const CHART_TEXT_STYLE = Object.freeze({ fontFamily: CHART_FONT_FAMILY });

// Etiquetas de los ejes X e Y.
export const AXIS_LABEL_TEXT = Object.freeze({ fontSize: 11, margin: 12 });

// Leyenda normal. `lineHeight` ≥ `fontSize` da alto de fila a la leyenda
// para que el clip vertical del modo scroll no recorte el tope del texto.
export const LEGEND_TEXT = Object.freeze({ fontSize: 12, fontWeight: 500, lineHeight: 18 });

export const TOOLTIP_TEXT = Object.freeze({ fontSize: 12 });
